// utils
import { ajaxRequestor, 
//getDocumentId,
//getMsg,
getMuid, getOriginReferer, getReferer, getRequestId, HttpMethod, getSessionId } from '../../utils/index.js';
export default class Reporter {
    config;
    constructor(config) {
        this.config = {};
        this.updateConfig(config);
    }
    updateConfig(config) {
        config.baseParams = config.baseParams ? config.baseParams : {};
        config.baseParams.type = config.baseParams.type
            ? config.baseParams.type
            : `MISSING: string value for telemetry 'type' in parent app`;
        config.baseParams.sessionId = `${config.baseParams.sessionId
            ? config.baseParams.sessionId
            : getSessionId()}`;
        config.baseParams.requestId = config.baseParams.requestId
            ? config.baseParams.requestId
            : getRequestId(window);
        // config.baseParams.creative - Provided by parent app
        config.baseParams.muid = config.baseParams.muid
            ? config.baseParams.muid
            : getMuid(window);
        config.baseParams.referer = config.baseParams.referer
            ? config.baseParams.referer
            : getReferer();
        config.baseParams.originReferer = config.baseParams.originReferer
            ? config.baseParams.originReferer
            : getOriginReferer();
        config.baseParams.appVersion = config.baseParams.appVersion
            ? config.baseParams.appVersion
            : `MISSING: string value for telemetry 'appVersion' in parent app`;
        config.baseParams.defaultShown =
            config.baseParams.defaultShown === null ||
                config.baseParams.defaultShown === undefined
                ? true
                : config.baseParams.defaultShown;
        this.config = config;
        this.config.url = this.initializeUrl(config.url);
    }
    async sendReport(event) {
        if (event.type)
            this.sendThirdPartyReport(event.type);
        const mapped = this.getMappedParams(event);
        if (this.config.method === HttpMethod.GET) {
            return this.sendGetReport(mapped);
        }
        return this.sendPostReport(mapped);
    }
    async sendPostReport(event) {
        // eslint-disable-next-line no-param-reassign
        event = this.getMappedParams(event);
        const init = {
            method: HttpMethod.POST,
            body: JSON.stringify({
                ...this.config.baseParams,
                ...event
            })
        };
        await ajaxRequestor.post(this.config.url, init);
        return;
    }
    async sendGetReport(event) {
        // eslint-disable-next-line no-useless-catch
        try {
            const url = this.getUrlWithQueryStringParams(event);
            await ajaxRequestor.get(url);
            return;
        }
        catch (err) {
            throw err;
        }
    }
    async sendThirdPartyReport(type) {
        try {
            if (!this.config.thirdPartyUrls ||
                !this.config.thirdPartyUrls[type]) {
                return;
            }
            this.config.thirdPartyUrls[type].forEach((url) => {
                ajaxRequestor.get(url);
            });
        }
        catch (err) {
            console.warn(`WARNING: error received when ending third party report for ${type}, err = `, err);
        }
    }
    getUrlWithQueryStringParams(event) {
        if (!this.config.baseParams) {
            return `${this.config.url}${this.objectToQueryString(event)}`;
        }
        return `${this.config.url}${this.objectToQueryString(this.config.baseParams)}&${this.objectToQueryString(event)}`;
    }
    getMappedParams(event) {
        if (!this.config.paramNameMap) {
            return event;
        }
        const mapConfig = this.config.paramNameMap.find((pnm) => pnm.type === event.type);
        if (!mapConfig) {
            return event;
        }
        const mappedParams = {};
        const keys = Object.keys(mapConfig.paramMap);
        const { length } = keys;
        let key;
        for (let i = 0; i < length; i++) {
            key = keys[i];
            if (Object.prototype.hasOwnProperty.call(event, key)) {
                mapConfig.paramMap[key] = event[key];
                // eslint-disable-next-line no-param-reassign
                delete event[key];
            }
        }
        return {
            ...event,
            ...mappedParams,
            ...mapConfig.staticParams
        };
    }
    /**
     * `objectToQueryString` converts and object into key/value query string formatted params
     * @param source: object - the params object to convert
     * @param parentKey: string - when nested child, the key of the parent object (for LHS brackets);
     * @returns string
     */
    objectToQueryString(source, parentKey) {
        const keys = Object.keys(source);
        const paramArray = [];
        for (let i = 0, l = keys.length; i < l; i++) {
            paramArray.push(this.getQueryParam(keys[i], source, parentKey));
        }
        return paramArray.join('&');
    }
    getQueryParam(key, source, parentKey) {
        const returnKey = !parentKey ? key : `${parentKey}[${key}]`;
        if (Array.isArray(source[key])) {
            const arr = source[key];
            return arr.map((val) => `${returnKey}[]=${val}`).join('&');
        }
        // https://www.moesif.com/blog/technical/api-design/REST-API-Design-Filtering-Sorting-and-Pagination/#lhs-brackets
        if (source[key] && typeof source[key] === 'object') {
            const obj = source[key];
            return this.objectToQueryString(obj, key);
        }
        return `${returnKey}=${source[key].toString()}`;
    }
    initializeUrl(url) {
        if (url.indexOf('?') === -1) {
            return `${url}?`;
        }
        const lastChar = url.charAt(url.length - 1);
        if (lastChar === '&' || lastChar === '?') {
            return url;
        }
        return `${url}&`;
    }
}
